import { render, staticRenderFns } from "./ArticleInfoTtsPlayer.vue?vue&type=template&id=1c72bb83&scoped=true"
import script from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoTtsPlayer.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoTtsPlayer.vue?vue&type=style&index=0&id=1c72bb83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72bb83",
  null
  
)

export default component.exports